import React, {FC, useEffect, useState} from "react";
import {Box, Spinner, Text, ThemeProvider} from "@primer/react";
import {ReadyState, LoadingTimings} from "./FormChannelControl";

interface FormEditorLoadingStateProps {
  readyState: ReadyState;
  timings: LoadingTimings;
}

const stateMessages: Record<ReadyState, string> = {
  initializing: "Initializing form editor...",
  connecting: "Connecting to server...",
  syncing: "Loading form data...",
  ready: "Ready",
  disconnected: "Connection lost",
};

export const FormEditorLoadingState: FC<FormEditorLoadingStateProps> = ({
  readyState,
  timings,
}) => {
  const [elapsed, setElapsed] = useState(0);
  const message = stateMessages[readyState];

  // Update elapsed time every 100ms while loading
  useEffect(() => {
    if (readyState === "ready") {
      return;
    }

    const startTime = timings.initStarted || performance.now();
    const interval = setInterval(() => {
      setElapsed(Math.round((performance.now() - startTime) / 100) / 10);
    }, 100);

    return () => clearInterval(interval);
  }, [readyState, timings.initStarted]);

  return (
    <ThemeProvider>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="var(--available-height)"
        sx={{
          bg: "canvas.default",
          gap: 3,
        }}
      >
        <Spinner size="large" />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          sx={{gap: 1}}
        >
          <Text
            sx={{
              color: "fg.muted",
              fontSize: 1,
            }}
          >
            {message}
          </Text>
          {elapsed > 0 && (
            <Text
              sx={{
                color: "fg.subtle",
                fontSize: 0,
                fontFamily: "mono",
              }}
            >
              {elapsed.toFixed(1)}s
            </Text>
          )}
        </Box>
      </Box>
    </ThemeProvider>
  );
};
